(() => {
  const header = document.querySelector('[data-header]');
  const headerSpacer = document.querySelector('[data-header-spacer]');
  const menuButton = document.querySelector('[data-mobile-menu-button]');
  const nav = document.querySelector('[data-primary-nav]');
  const megaTriggers = Array.from(document.querySelectorAll('[data-mega-trigger]'));
  const megaPanels = Array.from(document.querySelectorAll('[data-mega-panel]'));
  const searchToggles = Array.from(document.querySelectorAll('[data-search-toggle]'));
  const searchDrawer = document.querySelector('[data-search-drawer]');
  const searchClose = document.querySelector('[data-search-close]');
  const searchInput = document.querySelector('[data-search-input]');
  const searchSuggestions = document.querySelector('[data-search-suggestions]');
  const filterDrawer = document.querySelector('[data-filter-drawer]');
  const filterOpen = document.querySelector('[data-filter-open]');
  const filterCloseButtons = Array.from(document.querySelectorAll('[data-filter-close]'));
  const sortSheet = document.querySelector('[data-sort-sheet]');
  const sortSheetOpen = document.querySelector('[data-sort-sheet-open]');
  const sortSheetCloseButtons = Array.from(document.querySelectorAll('[data-sort-sheet-close]'));
  const sortForm = document.querySelector('[data-collection-sort-form]');
  const sortInput = sortForm?.querySelector('[data-sort-input]');
  const sortOptions = Array.from(document.querySelectorAll('[data-sort-option]'));
  const footerAccordions = Array.from(document.querySelectorAll('[data-footer-accordion]'));
  let headerOffsetTop = 0;
  let headerHeight = 0;
  let searchAbortController = null;
  let searchDebounceTimer = null;

  if (menuButton && nav) {
    menuButton.addEventListener('click', () => {
      const isOpen = nav.classList.toggle('is-open');
      menuButton.setAttribute('aria-expanded', String(isOpen));
      menuButton.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
    });
  }

  if (footerAccordions.length) {
    const footerDesktopQuery = window.matchMedia('(min-width: 750px)');
    const syncFooterAccordions = () => {
      footerAccordions.forEach((accordion) => {
        if (footerDesktopQuery.matches) {
          accordion.setAttribute('open', '');
        } else {
          accordion.removeAttribute('open');
        }
      });
    };

    syncFooterAccordions();
    footerDesktopQuery.addEventListener?.('change', syncFooterAccordions);
  }

  const heroCarousels = Array.from(document.querySelectorAll('[data-hero-carousel]'));
  heroCarousels.forEach((carousel) => {
    const slidesTrack = carousel.querySelector('[data-hero-slides]');
    const slides = Array.from(carousel.querySelectorAll('[data-hero-slide]'));
    const previousButton = carousel.querySelector('[data-hero-prev]');
    const nextButton = carousel.querySelector('[data-hero-next]');
    const dots = Array.from(carousel.querySelectorAll('[data-hero-dot]'));
    const reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    const interval = Math.max(Number(carousel.dataset.autoplayInterval || 5000), 3000);
    const autoplayEnabled = carousel.dataset.autoplay === 'true' && slides.length > 1;
    let activeIndex = Math.max(slides.findIndex((slide) => slide.classList.contains('is-active')), 0);
    let autoplayTimer = null;
    let isHoverPaused = false;
    let isUserPaused = false;
    let touchStartX = 0;
    let touchStartY = 0;
    let touchCurrentX = 0;
    let touchCurrentY = 0;
    let isSwiping = false;
    const swipeThreshold = 44;
    const swipeIntentRatio = 1.35;

    if (!slidesTrack || slides.length <= 0) return;

    const stopAutoplay = () => {
      if (autoplayTimer) {
        window.clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    };

    const canAutoplay = () => (
      autoplayEnabled
      && !reduceMotionQuery.matches
      && !document.hidden
      && !isHoverPaused
      && !isUserPaused
    );

    const startAutoplay = () => {
      stopAutoplay();
      if (!canAutoplay()) return;
      autoplayTimer = window.setInterval(() => {
        goToSlide(activeIndex + 1);
      }, interval);
    };

    function goToSlide(index) {
      const nextIndex = (index + slides.length) % slides.length;
      activeIndex = nextIndex;
      slidesTrack.style.transform = `translateX(-${nextIndex * 100}%)`;

      slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === nextIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', String(!isActive));
      });

      dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === nextIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', String(isActive));
      });

      if (previousButton) previousButton.setAttribute('aria-disabled', 'false');
      if (nextButton) nextButton.setAttribute('aria-disabled', 'false');
    }

    const handleUserNavigation = (index) => {
      isUserPaused = true;
      stopAutoplay();
      goToSlide(index);
    };

    previousButton?.addEventListener('click', () => handleUserNavigation(activeIndex - 1));
    nextButton?.addEventListener('click', () => handleUserNavigation(activeIndex + 1));

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        handleUserNavigation(Number(dot.dataset.slideIndex || 0));
      });
    });

    carousel.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        handleUserNavigation(activeIndex - 1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        handleUserNavigation(activeIndex + 1);
      }
    });

    carousel.addEventListener('touchstart', (event) => {
      if (event.touches.length !== 1) return;
      touchStartX = event.touches[0].clientX;
      touchStartY = event.touches[0].clientY;
      touchCurrentX = touchStartX;
      touchCurrentY = touchStartY;
      isSwiping = true;
    }, { passive: true });

    carousel.addEventListener('touchmove', (event) => {
      if (!isSwiping || event.touches.length !== 1) return;
      touchCurrentX = event.touches[0].clientX;
      touchCurrentY = event.touches[0].clientY;
    }, { passive: true });

    carousel.addEventListener('touchend', () => {
      if (!isSwiping) return;
      const deltaX = touchCurrentX - touchStartX;
      const deltaY = touchCurrentY - touchStartY;
      const isHorizontalSwipe = Math.abs(deltaX) >= swipeThreshold && Math.abs(deltaX) > Math.abs(deltaY) * swipeIntentRatio;
      isSwiping = false;

      if (!isHorizontalSwipe) return;
      handleUserNavigation(deltaX < 0 ? activeIndex + 1 : activeIndex - 1);
    });

    carousel.addEventListener('touchcancel', () => {
      isSwiping = false;
    });

    carousel.addEventListener('mouseenter', () => {
      isHoverPaused = true;
      stopAutoplay();
    });

    carousel.addEventListener('mouseleave', () => {
      isHoverPaused = false;
      startAutoplay();
    });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        stopAutoplay();
      } else {
        startAutoplay();
      }
    });

    reduceMotionQuery.addEventListener?.('change', startAutoplay);

    goToSlide(activeIndex);
    startAutoplay();
  });

  if (header) {
    const isHomeTransparentHeader = header.classList.contains('site-header--home-transparent');
    const homeLogoDrawer = header.querySelector('[data-home-logo-drawer]');
    const hero = isHomeTransparentHeader ? document.querySelector('.hero') : null;
    let lastScrollY = window.scrollY;
    let heroEndY = 0;

    const measureHeader = () => {
      const wasPinned = header.classList.contains('header-pinned');
      if (wasPinned) {
        header.classList.remove('header-pinned');
        if (headerSpacer) headerSpacer.style.height = '0px';
      }

      const rect = header.getBoundingClientRect();
      headerOffsetTop = rect.top + window.scrollY;
      headerHeight = rect.height;
      if (hero) {
        const heroRect = hero.getBoundingClientRect();
        heroEndY = heroRect.top + window.scrollY + heroRect.height;
      }

      if (wasPinned) {
        header.classList.add('header-pinned');
        if (headerSpacer && !isHomeTransparentHeader) headerSpacer.style.height = `${headerHeight}px`;
      }
    };

    const syncHeaderState = () => {
      const currentScrollY = Math.max(window.scrollY, 0);
      const isPastHeader = currentScrollY > headerOffsetTop + 8;
      const isScrollingUp = currentScrollY < lastScrollY - 4;
      const isScrollingDown = currentScrollY > lastScrollY + 4;
      const isPastHero = heroEndY > 0 && currentScrollY >= Math.max(heroEndY - headerHeight, 0);
      let isPinned = currentScrollY >= headerOffsetTop;

      if (isHomeTransparentHeader) {
        if (!isPastHeader) {
          isPinned = false;
        } else if (isScrollingDown && !isPastHero) {
          isPinned = true;
        } else if (isScrollingDown && isPastHero) {
          isPinned = false;
        } else if (isScrollingUp) {
          isPinned = true;
        } else {
          isPinned = header.classList.contains('header-pinned');
        }
      }

      const progress = isHomeTransparentHeader
        ? (currentScrollY > 8 ? 1 : 0)
        : Math.min(Math.max(currentScrollY / Math.max(headerHeight * 3, 1), 0), 1);
      header.classList.toggle('header-pinned', isPinned);
      header.classList.toggle('header-scrolled', currentScrollY > 8);
      if (homeLogoDrawer) {
        header.style.setProperty('--home-logo-progress', progress.toFixed(3));
        header.style.setProperty('--home-logo-opacity', (1 - progress).toFixed(3));
        header.style.setProperty('--home-logo-scale', (1 - progress * 0.78).toFixed(3));
        header.style.setProperty('--home-logo-shift', `${Math.round(progress * -72)}px`);
      }

      if (headerSpacer) {
        headerSpacer.style.height = isPinned && !isHomeTransparentHeader ? `${headerHeight}px` : '0px';
      }

      lastScrollY = currentScrollY;
    };

    measureHeader();
    syncHeaderState();
    window.addEventListener('resize', () => {
      measureHeader();
      syncHeaderState();
    });
    window.addEventListener('scroll', syncHeaderState, { passive: true });
  }

  const closeMegaMenus = () => {
    megaTriggers.forEach((trigger) => {
      trigger.setAttribute('aria-expanded', 'false');
      const item = trigger.closest('.nav-item--has-mega');
      if (item) item.classList.remove('is-open');
    });
    megaPanels.forEach((panel) => panel.setAttribute('aria-hidden', 'true'));
  };

  const escapeHTML = (value) => {
    const element = document.createElement('span');
    element.textContent = value || '';
    return element.innerHTML;
  };

  const formatMoney = (value) => {
    if (value === null || value === undefined || value === '') return '';
    if (typeof value === 'string') return value;
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(value);
    }

    const amount = Number(value || 0) / 100;
    return amount.toLocaleString(undefined, {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'USD',
    });
  };

  const setSearchSuggestionsState = (content = '', state = '') => {
    if (!searchSuggestions) return;
    searchSuggestions.innerHTML = content;
    searchSuggestions.dataset.state = state;
  };

  const closeSearchDrawer = () => {
    if (!searchDrawer) return;
    searchDrawer.classList.remove('is-open');
    searchDrawer.setAttribute('aria-hidden', 'true');
    searchToggles.forEach((toggle) => toggle.setAttribute('aria-expanded', 'false'));
    if (searchAbortController) searchAbortController.abort();
  };

  const openSearchDrawer = () => {
    if (!searchDrawer) return;
    closeMegaMenus();
    searchDrawer.classList.add('is-open');
    searchDrawer.setAttribute('aria-hidden', 'false');
    searchToggles.forEach((toggle) => toggle.setAttribute('aria-expanded', 'true'));
    window.setTimeout(() => {
      if (searchInput) searchInput.focus();
    }, 80);
  };

  const closeCollectionDrawers = () => {
    if (filterDrawer) {
      filterDrawer.classList.remove('is-open');
      filterDrawer.setAttribute('aria-hidden', 'true');
      if (filterOpen) filterOpen.setAttribute('aria-expanded', 'false');
    }

    if (sortSheet) {
      sortSheet.classList.remove('is-open');
      sortSheet.setAttribute('aria-hidden', 'true');
      if (sortSheetOpen) sortSheetOpen.setAttribute('aria-expanded', 'false');
    }

    filterCloseButtons.forEach((button) => {
      if (button.matches('.collection-filter-overlay')) button.classList.remove('is-open');
    });
    sortSheetCloseButtons.forEach((button) => {
      if (button.matches('.collection-sort-overlay')) button.classList.remove('is-open');
    });
    document.documentElement.classList.remove('collection-drawer-open', 'collection-sort-sheet-open');
  };

  const openFilterDrawer = () => {
    if (!filterDrawer) return;
    closeSearchDrawer();
    if (sortSheet) {
      sortSheet.classList.remove('is-open');
      sortSheet.setAttribute('aria-hidden', 'true');
      if (sortSheetOpen) sortSheetOpen.setAttribute('aria-expanded', 'false');
    }
    filterDrawer.classList.add('is-open');
    filterDrawer.setAttribute('aria-hidden', 'false');
    if (filterOpen) filterOpen.setAttribute('aria-expanded', 'true');
    filterCloseButtons.forEach((button) => {
      if (button.matches('.collection-filter-overlay')) button.classList.add('is-open');
    });
    sortSheetCloseButtons.forEach((button) => {
      if (button.matches('.collection-sort-overlay')) button.classList.remove('is-open');
    });
    document.documentElement.classList.add('collection-drawer-open');
    document.documentElement.classList.remove('collection-sort-sheet-open');
  };

  const openSortSheet = () => {
    if (!sortSheet) return;
    closeSearchDrawer();
    if (filterDrawer) {
      filterDrawer.classList.remove('is-open');
      filterDrawer.setAttribute('aria-hidden', 'true');
      if (filterOpen) filterOpen.setAttribute('aria-expanded', 'false');
    }
    sortSheet.classList.add('is-open');
    sortSheet.setAttribute('aria-hidden', 'false');
    if (sortSheetOpen) sortSheetOpen.setAttribute('aria-expanded', 'true');
    sortSheetCloseButtons.forEach((button) => {
      if (button.matches('.collection-sort-overlay')) button.classList.add('is-open');
    });
    filterCloseButtons.forEach((button) => {
      if (button.matches('.collection-filter-overlay')) button.classList.remove('is-open');
    });
    document.documentElement.classList.add('collection-sort-sheet-open');
    document.documentElement.classList.remove('collection-drawer-open');
  };

  const renderPredictiveProducts = (products, query) => {
    if (!products.length) {
      setSearchSuggestionsState(`<p class="search-suggestions-empty">No products found for "${escapeHTML(query)}".</p>`, 'empty');
      return;
    }

    const items = products.map((product) => {
      const image = product.image || product.featured_image || {};
      const imageUrl = typeof image === 'string' ? image : image.url;
      const imageAlt = typeof image === 'object' && image.alt ? image.alt : product.title;
      const price = product.price || product.price_min;

      return `
        <a class="search-suggestion-item" href="${escapeHTML(product.url)}">
          <span class="search-suggestion-media">
            ${imageUrl ? `<img src="${escapeHTML(imageUrl)}" alt="${escapeHTML(imageAlt)}" loading="lazy">` : '<span class="search-suggestion-placeholder"></span>'}
          </span>
          <span class="search-suggestion-copy">
            <span class="search-suggestion-title">${escapeHTML(product.title)}</span>
            ${price ? `<span class="search-suggestion-price">${escapeHTML(formatMoney(price))}</span>` : ''}
          </span>
        </a>
      `;
    }).join('');

    setSearchSuggestionsState(`
      <div class="search-suggestions-grid">
        ${items}
      </div>
      <a class="search-suggestions-view-all" href="/search?q=${encodeURIComponent(query)}&type=product&options%5Bprefix%5D=last">View all results</a>
    `, 'results');
  };

  const fetchPredictiveSearch = (query) => {
    if (!searchSuggestions) return;
    if (searchAbortController) searchAbortController.abort();

    const trimmedQuery = query.trim();
    if (!trimmedQuery) {
      setSearchSuggestionsState('', '');
      return;
    }

    searchAbortController = new AbortController();
    setSearchSuggestionsState('<p class="search-suggestions-loading">Searching...</p>', 'loading');

    const suggestUrl = `/search/suggest.json?q=${encodeURIComponent(trimmedQuery)}&resources[type]=product&resources[limit]=6`;

    fetch(suggestUrl, { signal: searchAbortController.signal })
      .then((response) => {
        if (!response.ok) throw new Error('Predictive search request failed');
        return response.json();
      })
      .then((data) => {
        const products = data?.resources?.results?.products || [];
        renderPredictiveProducts(products.slice(0, 6), trimmedQuery);
      })
      .catch((error) => {
        if (error.name === 'AbortError') return;
        setSearchSuggestionsState('<p class="search-suggestions-empty">Search suggestions are unavailable.</p>', 'error');
      });
  };

  if (searchToggles.length && searchDrawer) {
    searchToggles.forEach((searchToggle) => searchToggle.addEventListener('click', (event) => {
      event.preventDefault();
      openSearchDrawer();
    }));
  }

  if (searchClose) {
    searchClose.addEventListener('click', closeSearchDrawer);
  }

  if (filterOpen && filterDrawer) {
    filterOpen.addEventListener('click', (event) => {
      event.preventDefault();
      openFilterDrawer();
    });
  }

  filterCloseButtons.forEach((button) => {
    button.addEventListener('click', closeCollectionDrawers);
  });

  if (sortSheetOpen && sortSheet) {
    sortSheetOpen.addEventListener('click', (event) => {
      event.preventDefault();
      openSortSheet();
    });
  }

  sortSheetCloseButtons.forEach((button) => {
    button.addEventListener('click', closeCollectionDrawers);
  });

  sortOptions.forEach((option) => {
    option.addEventListener('click', () => {
      if (!sortForm || !sortInput) return;
      sortInput.value = option.dataset.sortValue || '';
      sortOptions.forEach((candidate) => candidate.classList.toggle('is-selected', candidate === option));
      sortForm.submit();
    });
  });

  document.querySelectorAll('[data-product-card]').forEach((card) => {
    const primaryImage = card.querySelector('[data-product-card-primary-image]');
    const swatches = Array.from(card.querySelectorAll('[data-product-card-swatch]'));

    if (!primaryImage || !swatches.length) return;

    const defaultImage = {
      src: primaryImage.currentSrc || primaryImage.src,
      srcset: primaryImage.getAttribute('srcset') || '',
      alt: primaryImage.getAttribute('alt') || '',
    };

    const setPreviewImage = (swatch) => {
      const previewSrc = swatch.dataset.swatchPreviewSrc;
      if (!previewSrc) return;

      primaryImage.src = previewSrc;
      if (swatch.dataset.swatchPreviewSrcset) {
        primaryImage.setAttribute('srcset', swatch.dataset.swatchPreviewSrcset);
      }
      if (swatch.dataset.swatchPreviewAlt) {
        primaryImage.setAttribute('alt', swatch.dataset.swatchPreviewAlt);
      }

      swatches.forEach((candidate) => {
        candidate.classList.toggle('is-active', candidate === swatch);
      });
    };

    const restoreDefaultImage = () => {
      primaryImage.src = defaultImage.src;
      if (defaultImage.srcset) {
        primaryImage.setAttribute('srcset', defaultImage.srcset);
      } else {
        primaryImage.removeAttribute('srcset');
      }
      primaryImage.setAttribute('alt', defaultImage.alt);

      swatches.forEach((candidate, index) => {
        candidate.classList.toggle('is-active', index === 0);
      });
    };

    swatches.forEach((swatch) => {
      swatch.addEventListener('mouseenter', () => setPreviewImage(swatch));
      swatch.addEventListener('focus', () => setPreviewImage(swatch));
      swatch.addEventListener('mouseleave', restoreDefaultImage);
      swatch.addEventListener('blur', restoreDefaultImage);
    });
  });

  if (searchInput) {
    searchInput.addEventListener('input', () => {
      window.clearTimeout(searchDebounceTimer);
      searchDebounceTimer = window.setTimeout(() => {
        fetchPredictiveSearch(searchInput.value);
      }, 220);
    });
  }

  megaTriggers.forEach((trigger) => {
    const item = trigger.closest('.nav-item--has-mega');
    if (!item) return;

    trigger.addEventListener('mouseenter', () => {
      closeMegaMenus();
      item.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      const panel = item.querySelector('[data-mega-panel]');
      if (panel) panel.setAttribute('aria-hidden', 'false');
    });

    item.addEventListener('mouseleave', () => {
      item.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      const panel = item.querySelector('[data-mega-panel]');
      if (panel) panel.setAttribute('aria-hidden', 'true');
    });

    trigger.addEventListener('focus', () => {
      closeMegaMenus();
      item.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      const panel = item.querySelector('[data-mega-panel]');
      if (panel) panel.setAttribute('aria-hidden', 'false');
    });

    item.addEventListener('focusout', (event) => {
      if (!item.contains(event.relatedTarget)) {
        item.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
        const panel = item.querySelector('[data-mega-panel]');
        if (panel) panel.setAttribute('aria-hidden', 'true');
      }
    });
  });

  document.addEventListener('click', (event) => {
    const clickedHeader = header && header.contains(event.target);
    if (!clickedHeader) {
      closeMegaMenus();
      closeSearchDrawer();
      if (nav && menuButton) {
        nav.classList.remove('is-open');
        menuButton.setAttribute('aria-expanded', 'false');
        menuButton.setAttribute('aria-label', 'Open menu');
      }
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    closeMegaMenus();
    closeSearchDrawer();
    closeCollectionDrawers();
    closeCartDrawer();
    if (nav && menuButton) {
      nav.classList.remove('is-open');
      menuButton.setAttribute('aria-expanded', 'false');
      menuButton.setAttribute('aria-label', 'Open menu');
      menuButton.focus();
    }
  });

  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartDrawerItems = cartDrawer?.querySelector('[data-cart-drawer-items]');
  const cartDrawerMessage = cartDrawer?.querySelector('[data-cart-drawer-message]');
  const cartDrawerSubtotal = cartDrawer?.querySelector('[data-cart-drawer-subtotal]');
  const cartDrawerTitle = cartDrawer?.querySelector('[data-cart-drawer-count]');
  const cartDrawerShippingMessage = cartDrawer?.querySelector('[data-cart-drawer-shipping-message]');
  const cartDrawerShippingProgress = cartDrawer?.querySelector('[data-cart-drawer-shipping-progress]');
  const cartCount = document.querySelector('.cart-count');
  const cartToggles = document.querySelectorAll('[data-cart-toggle]');
  let isCartUpdating = false;

  const openCartDrawer = () => {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    cartToggles.forEach((toggle) => toggle.setAttribute('aria-expanded', 'true'));
    document.documentElement.classList.add('cart-drawer-open');
  };

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    cartToggles.forEach((toggle) => toggle.setAttribute('aria-expanded', 'false'));
    document.documentElement.classList.remove('cart-drawer-open');
  }

  const setCartUpdating = (isUpdating) => {
    isCartUpdating = isUpdating;
    cartDrawer?.classList.toggle('is-updating', isUpdating);
    cartDrawer?.querySelectorAll('[data-cart-quantity-action], [data-cart-remove]').forEach((button) => {
      button.disabled = isUpdating;
    });
  };

  const renderFreeShipping = (cart) => {
    if (!cartDrawerShippingMessage || !cartDrawerShippingProgress) return;

    const threshold = Number(cartDrawer?.dataset.freeShippingThreshold || 0);
    if (!threshold) {
      cartDrawerShippingMessage.textContent = '';
      cartDrawerShippingProgress.style.width = '0%';
      return;
    }

    const total = Number(cart.total_price || 0);
    const remaining = Math.max(threshold - total, 0);
    const progress = Math.min((total / threshold) * 100, 100);
    const unlockedMessage = cartDrawer?.dataset.freeShippingUnlockedMessage || 'You have unlocked FREE shipping!';
    const messageTemplate = cartDrawer?.dataset.freeShippingMessageTemplate || 'Spend {{ amount }} more for FREE shipping!';

    cartDrawerShippingMessage.textContent = remaining > 0
      ? messageTemplate.replace('{{ amount }}', formatMoney(remaining)).replace('[amount]', formatMoney(remaining))
      : unlockedMessage;
    cartDrawerShippingProgress.style.width = `${progress}%`;
  };

  const renderCartDrawer = (cart, message = '') => {
    if (!cartDrawer) return;
    if (cartCount) cartCount.textContent = cart.item_count || '';
    if (cartDrawerTitle) {
      const titleBase = cartDrawerTitle.dataset.cartDrawerTitleBase || 'YOUR CART';
      cartDrawerTitle.textContent = `${titleBase} (${cart.item_count || 0})`;
    }
    if (cartDrawerSubtotal) cartDrawerSubtotal.textContent = formatMoney(cart.total_price);
    if (cartDrawerMessage) cartDrawerMessage.textContent = message;
    renderFreeShipping(cart);

    if (!cartDrawerItems) return;
    if (!cart.items?.length) {
      cartDrawerItems.innerHTML = '<p class="cart-drawer-empty">Your bag is currently empty.</p>';
      return;
    }

    cartDrawerItems.innerHTML = cart.items.map((item) => {
      const image = item.image ? `<img src="${escapeHTML(item.image)}" alt="${escapeHTML(item.product_title)}" loading="lazy">` : '<span class="cart-drawer-item-placeholder"></span>';
      const options = item.options_with_values?.length
        ? item.options_with_values
          .filter((option) => option.value && option.value !== 'Default Title')
          .map((option) => `<span>${escapeHTML(option.name)}: ${escapeHTML(option.value)}</span>`)
          .join('')
        : '';

      return `
        <article class="cart-drawer-item" data-cart-line-key="${escapeHTML(item.key)}">
          <a class="cart-drawer-item-media" href="${escapeHTML(item.url)}">${image}</a>
          <div class="cart-drawer-item-copy">
            <a class="cart-drawer-item-title" href="${escapeHTML(item.url)}">${escapeHTML(item.product_title)}</a>
            <div class="cart-drawer-item-options">${options}</div>
            <div class="cart-drawer-item-actions">
              <div class="cart-drawer-quantity" aria-label="Quantity for ${escapeHTML(item.product_title)}">
                <button type="button" data-cart-quantity-action="decrease" data-cart-line-key="${escapeHTML(item.key)}" data-cart-line-quantity="${item.quantity}" aria-label="Decrease quantity">-</button>
                <span>${item.quantity}</span>
                <button type="button" data-cart-quantity-action="increase" data-cart-line-key="${escapeHTML(item.key)}" data-cart-line-quantity="${item.quantity}" aria-label="Increase quantity">+</button>
              </div>
              <button class="cart-drawer-remove" type="button" data-cart-remove data-cart-line-key="${escapeHTML(item.key)}" aria-label="Remove ${escapeHTML(item.product_title)}">
                <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 7h12"></path><path d="M10 7V5h4v2"></path><path d="M8 7l1 13h6l1-13"></path></svg>
              </button>
              <span class="cart-drawer-line-price">${escapeHTML(formatMoney(item.final_line_price))}</span>
            </div>
          </div>
        </article>
      `;
    }).join('');
  };

  const updateCartLine = (lineKey, quantity) => {
    if (!lineKey || isCartUpdating) return;

    setCartUpdating(true);
    if (cartDrawerMessage) cartDrawerMessage.textContent = '';

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: lineKey,
        quantity: Math.max(Number(quantity) || 0, 0),
      }),
    })
      .then((response) => {
        if (!response.ok) throw new Error('Unable to update cart');
        return response.json();
      })
      .then((cart) => {
        renderCartDrawer(cart);
      })
      .catch(() => {
        if (cartDrawerMessage) cartDrawerMessage.textContent = 'We could not update your bag. Please try again.';
      })
      .finally(() => {
        setCartUpdating(false);
      });
  };

  const loadAndOpenCartDrawer = (fallbackUrl) => {
    if (!cartDrawer) {
      if (fallbackUrl) window.location.href = fallbackUrl;
      return;
    }

    setCartUpdating(true);
    if (cartDrawerMessage) cartDrawerMessage.textContent = '';

    fetch('/cart.js', {
      headers: {
        Accept: 'application/json',
      },
    })
      .then((response) => {
        if (!response.ok) throw new Error('Unable to load cart');
        return response.json();
      })
      .then((cart) => {
        renderCartDrawer(cart);
        openCartDrawer();
      })
      .catch(() => {
        if (fallbackUrl) window.location.href = fallbackUrl;
      })
      .finally(() => {
        setCartUpdating(false);
      });
  };

  if (cartDrawer) {
    cartDrawer.querySelectorAll('[data-cart-drawer-close]').forEach((button) => {
      button.addEventListener('click', closeCartDrawer);
    });

    cartDrawer.addEventListener('click', (event) => {
      const quantityButton = event.target.closest('[data-cart-quantity-action]');
      if (quantityButton) {
        const currentQuantity = Number(quantityButton.dataset.cartLineQuantity || 0);
        const nextQuantity = quantityButton.dataset.cartQuantityAction === 'increase'
          ? currentQuantity + 1
          : currentQuantity - 1;
        updateCartLine(quantityButton.dataset.cartLineKey, nextQuantity);
        return;
      }

      const removeButton = event.target.closest('[data-cart-remove]');
      if (removeButton) {
        updateCartLine(removeButton.dataset.cartLineKey, 0);
      }
    });
  }

  cartToggles.forEach((toggle) => {
    toggle.addEventListener('click', (event) => {
      if (
        event.defaultPrevented ||
        event.button !== 0 ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey
      ) {
        return;
      }

      if (!cartDrawer) return;

      event.preventDefault();
      loadAndOpenCartDrawer(toggle.href);
    });
  });

  document.querySelectorAll('[data-product-form]').forEach((formWrapper) => {
    const productSection = formWrapper.closest('[data-section-id]');
    const productForm = formWrapper.querySelector('form');
    const variantInput = formWrapper.querySelector('[name="id"]');
    const optionButtons = Array.from(formWrapper.querySelectorAll('[data-option-button]'));
    const optionGroups = Array.from(formWrapper.querySelectorAll('[data-product-option]'));
    const addButton = formWrapper.querySelector('[name="add"]');
    const price = productSection?.querySelector('[data-price]');
    const availability = productSection?.querySelector('[data-availability]');
    const variantData = formWrapper.querySelector('[data-variant-json]');
    const mediaItems = Array.from(productSection?.querySelectorAll('[data-product-media]') || []);
    const shouldFilterMedia = productSection?.dataset.colorMediaFilter === 'true';
    const shouldUseCartDrawer = productSection?.dataset.cartDrawerEnabled === 'true';
    const addToCartLabel = addButton?.textContent.trim() || 'Add to bag';

    if (!variantInput || !variantData) return;

    const variants = JSON.parse(variantData.textContent);
    const selectedOptions = [];

    optionGroups.forEach((group) => {
      const index = Number(group.dataset.optionIndex);
      const selectedButton = group.querySelector('[data-option-button].is-selected') || group.querySelector('[data-option-button]');
      if (selectedButton) selectedOptions[index] = selectedButton.dataset.optionValue;
    });

    const getVariant = () => {
      if (!selectedOptions.length) return variants.find((variant) => String(variant.id) === String(variantInput.value)) || variants[0];
      return variants.find((variant) => {
        return selectedOptions.every((value, index) => !value || variant.options[index] === value);
      });
    };

    const formatVariantPrice = (cents) => {
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        return Shopify.formatMoney(cents);
      }

      const value = Number(cents || 0) / 100;
      return value.toLocaleString(undefined, {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'USD',
      });
    };

    const getColorToken = () => {
      const colorButton = optionButtons.find((button) => {
        const group = button.closest('[data-product-option]');
        const label = group?.querySelector('.product-option-label')?.childNodes?.[0]?.textContent || '';
        return /colou?r/i.test(label) && button.classList.contains('is-selected');
      });
      return colorButton?.dataset.optionToken || '';
    };

    const updateProductMedia = () => {
      if (!shouldFilterMedia || !mediaItems.length) return;

      const colorToken = getColorToken();
      let visibleCount = 0;

      mediaItems.forEach((item) => {
        const mediaToken = item.dataset.mediaColorToken;
        const isGeneric = !mediaToken;
        const isVisible = !colorToken || isGeneric || mediaToken === colorToken;
        item.classList.toggle('product-media--hidden', !isVisible);
        item.setAttribute('aria-hidden', String(!isVisible));
        if (isVisible) visibleCount += 1;
      });

      if (visibleCount === 0) {
        mediaItems.forEach((item) => {
          item.classList.remove('product-media--hidden');
          item.setAttribute('aria-hidden', 'false');
        });
      }
    };

    const updateAvailabilityForButtons = () => {
      optionButtons.forEach((button) => {
        const index = Number(button.dataset.optionIndex);
        const testOptions = selectedOptions.slice();
        testOptions[index] = button.dataset.optionValue;
        const hasAvailableMatch = variants.some((variant) => {
          return variant.available && testOptions.every((value, optionIndex) => !value || variant.options[optionIndex] === value);
        });
        button.disabled = !hasAvailableMatch;
        button.classList.toggle('is-unavailable', !hasAvailableMatch);
      });
    };

    const syncOptionLabels = () => {
      optionGroups.forEach((group) => {
        const index = Number(group.dataset.optionIndex);
        const labelValue = group.querySelector(`[data-option-label-value="${index}"]`);
        if (labelValue) labelValue.textContent = selectedOptions[index] || '';
      });
    };

    const updateVariant = () => {
      const variant = getVariant();
      if (!variant) return;

      variantInput.value = variant.id;
      if (price) price.textContent = formatVariantPrice(variant.price);

      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available ? addToCartLabel : 'Sold out';
      }

      if (availability) {
        availability.textContent = variant.available ? 'In stock' : 'Sold out';
      }

      updateAvailabilityForButtons();
      syncOptionLabels();
      updateProductMedia();

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({ path: url.toString() }, '', url.toString());
    };

    optionButtons.forEach((button) => {
      button.addEventListener('click', () => {
        if (button.disabled) return;
        const index = Number(button.dataset.optionIndex);
        selectedOptions[index] = button.dataset.optionValue;

        optionButtons
          .filter((candidate) => Number(candidate.dataset.optionIndex) === index)
          .forEach((candidate) => {
            const isSelected = candidate === button;
            candidate.classList.toggle('is-selected', isSelected);
            candidate.setAttribute('aria-pressed', String(isSelected));
          });

        updateVariant();
      });
    });

    updateVariant();

    if (productForm && shouldUseCartDrawer) {
      productForm.addEventListener('submit', (event) => {
        event.preventDefault();
        if (!addButton || addButton.disabled) return;

        addButton.disabled = true;
        addButton.textContent = 'Adding...';
        if (cartDrawerMessage) cartDrawerMessage.textContent = '';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
          },
          body: new FormData(productForm),
        })
          .then((response) => {
            if (!response.ok) throw new Error('Unable to add item to cart');
            return fetch('/cart.js', {
              headers: {
                Accept: 'application/json',
              },
            });
          })
          .then((response) => {
            if (!response.ok) throw new Error('Unable to load cart');
            return response.json();
          })
          .then((cart) => {
            renderCartDrawer(cart, 'Item added to your bag.');
            openCartDrawer();
          })
          .catch(() => {
            if (cartDrawerMessage) cartDrawerMessage.textContent = 'We could not add this item. Please try again.';
            openCartDrawer();
          })
          .finally(() => {
            const variant = getVariant();
            addButton.disabled = !variant?.available;
            addButton.textContent = variant?.available ? addToCartLabel : 'Sold out';
          });
      });
    }
  });
})();
